export const cadouri = [
    {
        id: "1",
        path: "/Cadouri/Cadouri-speciale",
        name: "Cadouri speciale",
        cName: "nav-dropdown"
    },
    {
        id: "2",
        path: "/Cadouri/Parfumuri",
        name: "Parfumuri",
        cName: "nav-dropdown"
    },
    {
        id: "3",
        path: "/Cadouri/Dulciuri",
        name: "Dulciuri",
        cName: "nav-dropdown"
    },
    {
        id: "4",
        path: "/Cadouri/Sampanie",
        name: "Sampanie",
        cName: "nav-dropdown"
    },
    {
        id: "5",
        path: "/Cadouri/Jucarii-&-Cadouri",
        name: "Jucarii & Cadouri",
        cName: "nav-dropdown"
    },
    {
        id: "6",
        path: "/Cadouri/Cosuri,-Vaze-&-Accesorii",
        name: "Cosuri, Vaze & Accesorii",
        cName: "nav-dropdown"
    },

]